import PostAddIcon from '@mui/icons-material/PostAdd';
import { useTheme } from '@mui/material';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const Post = () => {
  const theme = useTheme();

  return <PostAddIcon fontSize="medium" sx={tertiaryHoverSx(theme)} />;
};
